import axios from 'axios';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './plugins/vuelidate';
import './plugins/gmap-vue';
import AppPageLoader from './components/PageLoader.vue';
import { LOGOUT, RESTORE_AUTH } from './store/auth/types';

Vue.config.productionTip = false;
Vue.component('AppPageLoader', AppPageLoader);

const token = localStorage.getItem('authToken');
if (token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

axios.interceptors.request.use(config => {
  if (config.method === 'get' && !config.timeout) {
    config.timeout = 30000;
  }
  return config;
});

let sessionExpiryLogout = null;

axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    const requestHeaders = error.config && error.config.headers;
    const requestAuthorization = requestHeaders &&
      (requestHeaders.Authorization || requestHeaders.authorization) || null;
    const currentHeaders = axios.defaults.headers.common;
    const currentAuthorization = currentHeaders.Authorization || currentHeaders.authorization || null;
    const belongsToCurrentSession = !requestHeaders || requestAuthorization === currentAuthorization;

    const sessionRejected = error.response && (
      error.response.status === 401 || (error.response.status === 403 && /\/me(?:\?|$)/.test(error.config && error.config.url || ''))
    );
    if (
      sessionRejected &&
      router.currentRoute.name !== 'Signin' && !sessionExpiryLogout && belongsToCurrentSession
    ) {
      sessionExpiryLogout = store.dispatch(LOGOUT, { localOnly: true })
        .catch(logoutError => {
          console.error('Could not redirect after session expiry:', logoutError);
        })
        .finally(() => {
          sessionExpiryLogout = null;
        });
    }
    return Promise.reject(error);
  }
);

const mountApp = () => new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

if (token) {
  store.dispatch(RESTORE_AUTH).catch(() => {}).finally(mountApp);
} else {
  mountApp();
}
